<template>
    <ul>
      <li
        v-for="(item,index) in fromData "
        :key="index"
      >
        <div class="title" v-if="$store.state.companyList.isQlwVersion==true">
          <el-checkbox @change="checkedAll(item,item.isCheck)" v-model="item.isCheck">{{item.permissionName}}</el-checkbox>
          <div
            v-if="judge(item)"
            class="isCheck"
          >
            <span class="line"></span>
            <el-radio
              v-model="item.isReadOnly"
              :label="true"
            >只读权限</el-radio>
            <el-radio
              v-model="item.isReadOnly"
              :label="false"
            >编辑权限</el-radio>
          </div>
        </div>
        <div class="title" v-if="$store.state.companyList.isQlwVersion==false">
          <el-checkbox @change="checkedAll(item,item.isCheck)" v-model="item.isCheck" :disabled="!edit">{{item.permissionName}}</el-checkbox>
          <div
            v-if="judge(item)"
            class="isCheck"
          >
            <span class="line"></span>
            <el-radio
              v-model="item.isReadOnly"
              :label="true"
              :disabled="!edit"
            >只读权限</el-radio>
            <el-radio
              v-model="item.isReadOnly"
              :label="false"
              :disabled="!edit"
            >编辑权限</el-radio>
          </div>
        </div>
        <tree-menus v-if="item.menus"  :disabled="!edit" :fromData="item.menus" ></tree-menus>
      </li>
    </ul>
 
</template>

<script>
import checkPermission from "../../../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
import Vue from "vue";
export default Vue.extend({
  name: "TreeMenus",
  props: {
    fromData: Array
    // edit: Boolean
  },
  mixins: [mixins],
  data() {
    return {
      all: "",
      edit: ""
    };
  },
  mounted() {
    // console.log(mixins, this.companyList, 111);
    if (
      this.companyList.isQlwVersion == false ||
      this.companyList.isQlwVersion == null
    ) {
      let permission = this.loginUser.permissions.find(item => {
        return item.permissionId == this.permission.peopleManage;
      });
      if (permission) {
        this.edit = !permission.isReadOnly;
      }
    } else if (this.companyList.isQlwVersion == true) {
      checkPermission.checkEdit(this.$route).then(data => {
        this.edit = data;
      });
    }
  },
  computed: {
    filterData() {
      return this.kk(this.fromData);
    },
    // 判断是否显示权限的只读与编辑
    judge(val) {
      return function(val) {
        let arr = [
          100,
          101,
          102,
          103,
          104,
          105,
          106,
          107,
          200,
          222,
          230,
          243,
          250,
          244,
          245,
          246,
          247,
          248,
          249,
          516,
          101,
          209,
          210,
          211
        ];
        let id = val.permissionId;
        if (arr.indexOf(id) == -1 && val.isCheck == true) {
          return true;
        } else {
          return false;
        }
      };
    }
  },
  watch: {
    fromData: {
      handler(val) {
        this.checkedItem();
      },
      deep: true
    }
  },
  methods: {
    // 实现全选与全不选
    checkedAll(arr, c) {
      if (arr.menus) {
        console.log(arr.menus);
        arr.menus.forEach(element => {
          element.isCheck = c;
          if (element.menus) {
            console.log(element);
            this.checkedAll(element, element.isCheck);
          }
        });
      }
      this.checkedItem(this.fromData);
    },
    // 改变item
    checkedItem(arr) {
      this.fromData.forEach((item, i) => {
        if (item.menus && item.menus.length != 0) {
          let isAll = item.menus.every(m => {
            return m.isCheck == true;
          });
          if (isAll) {
            this.fromData[i].isCheck = true;
            //最顶层 判断是否全选
            let findObj = this.fromData.every(obj => {
              return obj.isCheck == true;
            });
            if (findObj) {
              this.$emit("judgeSelect", true);
            }
          } else {
            this.fromData[i].isCheck = false;
            this.$emit("judgeSelect", false);
          }
        }
      });
      // arr.forEach((item, i) => {
      //   if (item.menus && item.menus.length != 0) {
      //     let isAll = item.menus.every(m => {
      //       return m.isCheck == true;
      //     });
      //     if (isAll) {
      //       item.isCheck = true;
      //     } else {
      //       item.isCheck = false;
      //       this.$emit("judgeSelect", false);
      //     }
      //   }
      // });
    }
  }
});
</script>
<style lang="stylus">
.tree{
  .el-radio__input.is-checked+.el-radio__label,.el-radio__label {
    color: #333;
  }
  .el-checkbox{
    display inline-block;
    vertical-align:middle;
  }
  .isCheck {
    display: inline-block;
    vertical-align :-2px;
    .el-radio {
      display: inline-block;
      margin-left: 10px;
      margin-top: -3px;
      vertical-align: middle;
    }
    .line {
      display:inline-block;
      width: 12px;
      height: 1px;
      vertical-align: middle;
      margin-top: -6px;
      margin-left: 8px;
      background: #e0e0e0;
    }
  }
  .el-checkbox__label {
    color: #333;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #333;
  }
}

</style>

<style lang="stylus" scoped>
.title{
  height:26px;
}
ul {
  margin-left: 25px;
  color: #333;
}
</style>
